module.exports = __webpack_public_path__ + "product-compound-capsule-10.jpg?8392aa74f3247a7567798998f81a338e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-compound-capsule-10.jpg
// module id = 107
// module chunks = 0